module.exports = __webpack_public_path__ + "img/logo-white.f0cbd292.png";